import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=172740ee&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"
import style0 from "./Loading.vue?vue&type=style&index=0&id=172740ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172740ee",
  null
  
)

export default component.exports